import { useState, useEffect } from "react";
import { toast } from "sonner";
import DatePicker from "@/components/DatePicker";
import { api } from "@/lib/api";
import { X } from "lucide-react";

const MAHIYET_OPTIONS = ["Protokol Ödemesi", "İcra Taahhüt Ödemesi", "Ödeme Sözü", "Maaş Muvafakati"];

export default function OdemeSozuDialog({ title = "Ödeme Sözü Ekle", showTemsilci = true, initial = null, note = "", submitLabel = "Kaydet", onClose, onSubmit }) {
  const [f, setF] = useState({
    tarih: initial?.tarih || new Date().toISOString().slice(0, 10),
    temsilci: initial?.temsilci || "",
    mahiyet: initial?.mahiyet || "Ödeme Sözü",
    taahhut_tutari: initial?.taahhut_tutari ? String(initial.taahhut_tutari) : "",
    taahhut_tarihi: initial?.taahhut_tarihi || "",
    taahhut_sayisi: "1",
    aciklama: initial?.aciklama || "",
  });
  const [users, setUsers] = useState([]);
  const [saving, setSaving] = useState(false);
  const ch = (k, v) => setF((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    api.get("/users/names").then((r) => setUsers(r.data || [])).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.tarih) { toast.error("Görüşme tarihi zorunlu"); return; }
    setSaving(true);
    try {
      const base = { tarih: f.tarih, temsilci: f.temsilci || "", mahiyet: f.mahiyet || "", aciklama: f.aciklama || "" };
      const n = Math.max(1, parseInt(f.taahhut_sayisi, 10) || 1);
      if (!initial && n > 1 && f.taahhut_tarihi) {
        const total = Number(f.taahhut_tutari) || 0;
        const per = total ? Math.round((total / n) * 100) / 100 : 0;
        const d0 = new Date(f.taahhut_tarihi);
        const items = [];
        for (let k = 0; k < n; k++) {
          const d = new Date(d0.getFullYear(), d0.getMonth() + k, d0.getDate());
          const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
          const amt = (k === n - 1 && total) ? Math.round((total - per * (n - 1)) * 100) / 100 : per;
          items.push({ ...base, taahhut_tutari: amt, taahhut_tarihi: iso });
        }
        await onSubmit(items);
      } else {
        await onSubmit({ ...base, taahhut_tutari: Number(f.taahhut_tutari) || 0, taahhut_tarihi: f.taahhut_tarihi || null });
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <div className="bg-white border border-[#E7DECC] rounded-sm w-full max-w-md my-16" data-testid="odeme-sozu-dialog">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E7DECC]">
          <h3 className="font-heading text-lg font-bold tracking-tight">{title}</h3>
          <button onClick={onClose} data-testid="odeme-sozu-close" aria-label="Kapat" className="text-[#8C8377] hover:text-[#26231E]"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          {note && (
            <div className="px-3 py-2 rounded-sm bg-[#B8933F]/10 text-[#B8933F] text-xs font-semibold" data-testid="odeme-sozu-note">{note}</div>
          )}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="kicker block mb-1.5">GÖRÜŞME TARİHİ *</label>
              <DatePicker value={f.tarih} onChange={(v) => ch("tarih", v)} testId="sozu-tarih" />
            </div>
            {showTemsilci && (
              <div>
                <label className="kicker block mb-1.5">GÖRÜŞEN TEMSİLCİ</label>
                <select value={f.temsilci} onChange={(e) => ch("temsilci", e.target.value)} data-testid="sozu-temsilci" className="w-full px-3 py-2 border border-[#E7DECC] bg-white rounded-sm text-sm focus:outline-none focus:border-[#B8933F]">
                  <option value="">— Seçiniz —</option>
                  {users.map((u) => <option key={u.email} value={u.name || u.email}>{u.name || u.email}</option>)}
                </select>
              </div>
            )}
          </div>
          <div>
            <label className="kicker block mb-1.5">ÖDEME SÖZÜ MAHİYETİ</label>
            <select value={f.mahiyet} onChange={(e) => ch("mahiyet", e.target.value)} data-testid="sozu-mahiyet" className="w-full px-3 py-2 border border-[#E7DECC] bg-white rounded-sm text-sm focus:outline-none focus:border-[#B8933F]">
              {MAHIYET_OPTIONS.map((m) => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="kicker block mb-1.5">TAAHHÜT TUTARI</label>
              <input type="number" min="0" step="0.01" value={f.taahhut_tutari} onChange={(e) => ch("taahhut_tutari", e.target.value)} data-testid="sozu-tutar" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm tabular-nums focus:outline-none focus:border-[#B8933F]" placeholder="0" />
            </div>
            <div>
              <label className="kicker block mb-1.5">TAAHHÜT TARİHİ</label>
              <DatePicker value={f.taahhut_tarihi} onChange={(v) => ch("taahhut_tarihi", v)} placeholder="Ödeme sözü tarihi" testId="sozu-taahhut-tarih" />
            </div>
          </div>
          {!initial && (
            <div>
              <label className="kicker block mb-1.5">TAAHHÜT SAYISI (TAKSİT)</label>
              <input type="number" min="1" step="1" value={f.taahhut_sayisi} onChange={(e) => ch("taahhut_sayisi", e.target.value)} data-testid="sozu-taahhut-sayisi" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm tabular-nums focus:outline-none focus:border-[#B8933F]" placeholder="1" />
              <p className="text-xs text-[#8C8377] mt-1">1'den büyük girilirse, taahhüt tarihinden başlayarak <b>aylık periyotta</b> o kadar taksit oluşturulur ve tutar taksitlere eşit bölünür.</p>
            </div>
          )}
          <div>
            <label className="kicker block mb-1.5">NOT / AÇIKLAMA</label>
            <textarea value={f.aciklama} onChange={(e) => ch("aciklama", e.target.value)} rows={3} data-testid="sozu-aciklama" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm focus:outline-none focus:border-[#B8933F]" placeholder="Örn: 22.08.2026 tarihinde ödeme yapacak" />
          </div>
          <div className="flex justify-end gap-3 pt-1">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm font-medium hover:bg-[#EFE7D6] transition-colors duration-150">İptal</button>
            <button type="submit" disabled={saving} data-testid="sozu-save" className="px-6 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium transition-colors duration-150 disabled:opacity-60">{saving ? "Kaydediliyor..." : submitLabel}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
